import { Field } from "typegraph";
import { IUploadResponse } from "core/service/upload/IUploadService";

export default class Attachment implements IUploadResponse{

	@Field()
	public name: string;

	@Field()
	public url: string;

	@Field()
	public type: string;

}



// WEBPACK FOOTER //
// ./src/panels/forum/entity/Attachment.ts